import type {SystemColorScheme, ThemeId, ThemePreference} from "./types";

import {THEME_REGISTRY} from "./registry";
import {DEFAULT_THEME_ID} from "./types";

/**
 * Resolves a user ThemePreference to a concrete ThemeId.
 *
 * Pure function — no side effects, fully testable in isolation.
 *
 * @param preference - The stored user choice ('system' | ThemeId)
 * @param systemScheme - The current OS color scheme ('light' | 'dark')
 * @returns The ThemeId to apply to the UI
 */
export function resolveTheme(
  preference: ThemePreference,
  systemScheme: SystemColorScheme,
): ThemeId {
  if (preference !== "system") {
    return preference;
  }

  const match = Object.values(THEME_REGISTRY).find((config) => config.colorScheme === systemScheme);

  return match?.id ?? DEFAULT_THEME_ID;
}
